module.exports = __webpack_public_path__ + "img/discovery.d3c810cc.svg";